import styled from 'styled-components'


export const SC_Wrapper = styled.div`
  width: 100%;
  padding-top: 20px;
  display: flex;
  align-items: center;
  flex-direction: column;
`
